import {Component, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {Login} from "../infrastructure/models";
import {AuthService} from "../infrastructure/services";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent  implements OnInit {
  model: Login = new Login();
  returnUrl: string;
  constructor(private authenticationService: AuthService, private route: ActivatedRoute,
              private router: Router) {
  }
  ngOnInit() {
    // reset login status
    // this.authenticationService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  login() {
    this.authenticationService.login(this.model).subscribe(
      data => {
        this.router.navigate([this.returnUrl]);
      },
      error => {
        this.model  = new Login;
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/login/login.component.ts